import { useEffect } from 'react';

export const useEffectPreventZoom = () => {
	useEffect(() => {
		const handleMouseWheel = (event: WheelEvent) => {
			if (event.ctrlKey) {
				event.preventDefault();
			}
		};

		window.addEventListener('wheel', handleMouseWheel as EventListener, {
			passive: false,
		});

		return () => {
			window.removeEventListener('wheel', handleMouseWheel as EventListener);
		};
	}, []);
};
